
export function serializeMeasurements(measurements) {
  return measurements.reduce((total, current, key) => {
    return [...total, `${key}:${current}`];
  }, []).join('-');
}

export function serializeMeasurementsGetOnlyDecimals(measurements) {
  let serialized = "";
  const nrOfVals = Object.keys(measurements).length;
  for (let i = 0; i < nrOfVals; i++) {
    const letter = Object.keys(measurements)[i];
    serialized += letter + ":";
    let value = Object.values(measurements)[i].toString();
    if (value.includes(".")) {
      value = value.replace(".", "D");
    } 
    if (i === nrOfVals - 1) {
      serialized += value;
    } else {
      serialized += value + "-";
    }
  }
  return serialized;
}

export function serializeSingleMeasurementGetOnlyDecimals(measurement) {
  let serialized = measurement.toString();
  serialized = serialized.replace(".", "D");
  return serialized;
}

export function deserializeMeasurements(measurements) {
  return measurements.split('-').map((value) => value.split(':')).map(([key, value]) => [key, Number(value)]);
}
